import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Confiabilidade = () => {
  return (
    <>
     
      <Card className="text-center">
        <Card.Header><div className="opcoes">A configuração correta dos roteadores e dispositivos</div></Card.Header>
        <Card.Body>
          <Card.Title>Proteção contra ameaças</Card.Title>
          <Card.Text>
            <div className="opcoes">
              <strong>Ameaças Comuns: </strong>
              Ataques de hackers e invasões de privacidade são riscos frequentes em redes Wi-Fi.
            </div>
            <div className="opcoes">
              <strong>Boas Práticas de Segurança: </strong>
              Uso de senhas fortes e criptografia avançada, como WPA3, Firewall são essenciais para proteger a rede.
            </div>
            <div className="opcoes">
              <strong>Roteadores antigos: </strong>
              Muitos roteadores domésticos mais antigos não suportam os protocolos de segurança mais recentes, como WPA3.
            </div>
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted"><div className="opcoes">Configurações de
          segurança robustas, como WPA3 e Firewall, são essenciais para proteger a rede contra acessos não autorizados.</div></Card.Footer>
      </Card>
    </>
  )
}
export default Confiabilidade;